module.exports = __webpack_public_path__ + "static/media/shelton_toward.7054272d.jpg";